
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
	name: 'WhyHokifySection'
})
export default class WhyHokifySection extends Vue {
	@Prop({ type: String, default: '' }) readonly customButtonText?: string;

	clickedCTA(emitOnly: boolean) {
		if (!emitOnly) {
			this.$trackWebsiteEvent('go_to_pricing_page', { pageElement: 'why_hokify' });
		}
		this.$emit('clicked-cta');
	}
}
